import { render, staticRenderFns } from "./Cofounders.vue?vue&type=template&id=931ffdf4&scoped=true&"
import script from "./Cofounders.vue?vue&type=script&lang=js&"
export * from "./Cofounders.vue?vue&type=script&lang=js&"
import style0 from "./Cofounders.vue?vue&type=style&index=0&id=931ffdf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931ffdf4",
  null
  
)

export default component.exports